
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.697 6.343c.39-.39.944-.47 1.237-.177l9.9 9.9c.292.293.213.847-.177 1.237-.39.39-.945.47-1.238.177l-9.9-9.9c-.292-.292-.213-.846.178-1.237z","fill":"#001C46"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.343 17.303c-.39-.39-.47-.944-.177-1.237l9.9-9.9c.293-.293.847-.214 1.237.177.39.39.47.945.177 1.237l-9.9 9.9c-.292.293-.846.214-1.237-.177z","fill":"#001C46"}})])
          )
        }
      }
    